import { Box, makeStyles, Typography } from "@material-ui/core";
import { Warning } from "@material-ui/icons";
import { QualApprovalStatus } from "../../domain/Qualification";

const useStyles = makeStyles((theme) => ({
  iconSection: {
    padding: 10,
  },
  icon: {
    fontSize: "3rem",
  },
}));

export const ItemValidation: React.FC<{
  status?: QualApprovalStatus;
}> = ({ status }) => {
  const classes = useStyles();

  if (!status || status === QualApprovalStatus.Approved) {
    return null;
  }
  return (
    <Box display="flex" data-test="rejection-validation-metadata" alignItems="center">
      <div className={classes.iconSection}>
        <Warning className={classes.icon} />
      </div>
      <Typography>
        <b>{getMessage(status)}</b>
      </Typography>
    </Box>
  );
};

const getMessage = (status: QualApprovalStatus) => {
  switch (status) {
    case QualApprovalStatus.Rejected:
      return "This qualification has been rejected and requires resubmission";
    case QualApprovalStatus.AwaitingOfqualApproval:
    case QualApprovalStatus.AwaitingCceaApproval:
      return "There is a pending accreditation approval for this qualification";
    default:
      return null;
  }
};
